import React, { FC } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';
import { IResetPassLinkRequest } from '../../../services/resetPassword';
import InformationText from '../../InformationText/InformationText';
import Input from '../../Input/Input';
import ResetPassword from '../ResetPassword';
import { Headline, HeadlineBold } from '../ResetPassword.styles';
import { TextCont } from './ResetPasswordForm.styles';

interface IResetPassword {
  reset: (email: IResetPassLinkRequest) => void;
}

const ResetPasswordForm: FC<IResetPassword> = ({ reset }) => {
  const { t } = useTranslation();

  const resetPasswordSchema = object({
    email: string()
      .email(t('login.resetPassword.emailMustBeAValidEmail'))
      .required(t('login.resetPassword.emailIsRequired')),
  });

  const formMethods = useForm({
    defaultValues: {
      email: '',
    },
    resolver: yupResolver(resetPasswordSchema),
  });

  const { handleSubmit } = formMethods;

  const headline = (
    <Headline>
      <HeadlineBold>{t('login.resetPassword.password')}&nbsp;</HeadlineBold>
      {t('login.resetPassword.reset')}
    </Headline>
  );

  const resetPasswordForm = (
    <>
      <TextCont>
        <InformationText text={t('login.resetPassword.passwordResetText')} />
      </TextCont>
      <FormProvider {...formMethods}>
        <form data-testid="reset-password-form">
          <Input
            registerPath={'email'}
            label={t('login.resetPassword.email')}
            placeholder={t('login.resetPassword.yourEmailAddress')}
          />
        </form>
      </FormProvider>
    </>
  );

  return (
    <ResetPassword
      headline={headline}
      content={resetPasswordForm}
      submit={handleSubmit(data => reset(data))}
      buttonText={t('login.resetPassword.resetMyPassword')}
    />
  );
};

export default ResetPasswordForm;
